exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400);", ""]);

// module
exports.push([module.id, ".search-input-2 {\n    width: 100%;\n    height: 100%;\n    padding: 0 1em;\n    border: 0;\n    background-color: transparent;\n    color: #fff;\n}\n\n.search-input-2:focus {\n    outline: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/section/header/header.component.css
// module id = ../../../../../src/app/section/header/header.component.css
// module chunks = main